import type { SessionRow } from "./talks";

export type SessionOccurrence = {
  id: string;
  event: string;
  eventWebsite: string | null;
  date: string;
  startDateTimestamp: number;
  endDate: string;
  endDateTimestamp: number;
  location: string | null;
  year: string;
  sessions: SessionRow[];
  hasMaterials: boolean;
};

const occurrenceKey = (event: string, date: string, location: string | null) =>
  `${event}__${date}__${location ?? "unknown"}`;

export function groupSessionsByOccurrence(
  sessions: SessionRow[],
): SessionOccurrence[] {
  const grouped = Map.groupBy(sessions, (session) =>
    occurrenceKey(session.event, session.date, session.location),
  );

  return Array.from(grouped.entries())
    .map(([id, groupSessions]) => {
      const first = groupSessions[0]!;
      return {
        id,
        event: first.event,
        eventWebsite: first.eventWebsite,
        date: first.date,
        startDateTimestamp: first.startDateTimestamp,
        endDate: first.endDate,
        endDateTimestamp: first.endDateTimestamp,
        location: first.location,
        year: first.date.substring(0, 4),
        sessions: groupSessions,
        hasMaterials: groupSessions.some(
          (s) => s.slidesUrl || s.codeUrl || s.recordingUrl,
        ),
      };
    })
    .sort((a, b) => b.startDateTimestamp - a.startDateTimestamp);
}
